<mat-accordion [multi]="true">
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>Reporte de órdenes y documentos por edición</mat-expansion-panel-header>
    <div fxLayout="row" fxLayout.xs="column">
      <div fxFlex></div>
      <mat-form-field>
        <input matInput [matDatepicker]="editionDate" placeholder="Seleccione una fecha" (dateChange)="onChange($event)">
        <mat-datepicker-toggle matSuffix [for]="editionDate"></mat-datepicker-toggle>
        <mat-datepicker #editionDate></mat-datepicker>
      </mat-form-field>
      <div fxFlex></div>
    </div>
    <div fxLayout="row">
      <div fxFlex></div>
      <a [disabled]="!selectedDate" href="/reporte/basico/{{selectedDate | date: 'yyyy-MM-dd'}}"
        target="_blank" mat-button color="primary">Ver Reporte</a>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>Reporte de uso de OCR</mat-expansion-panel-header>
    <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column">
      <div fxFlex></div>
      <mat-form-field>
        <input matInput [max]="selectedEndDate" [matDatepicker]="startDate" placeholder="Inicio" (dateChange)="onStartDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <input matInput [min]="selectedStartDate" [matDatepicker]="endDate" placeholder="Fin" (dateChange)="onEndDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
      </mat-form-field>
      <div fxFlex></div>
    </div>
    <div fxLayout="row">
      <div fxFlex></div>
      <a [disabled]="!selectedEndDate || !selectedStartDate" href="/reporte/ocr/{{selectedStartDate | date: 'yyyy-MM-dd'}}/{{selectedEndDate | date: 'yyyy-MM-dd'}}"
        target="_blank" mat-button color="primary">Ver Reporte</a>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>Reporte de uso de Certificaciones</mat-expansion-panel-header>
    <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column">
      <div fxFlex></div>
      <mat-form-field>
        <input matInput [max]="certSelectedEndDate" [matDatepicker]="certStartDate" placeholder="Inicio" (dateChange)="onCertStartDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="certStartDate"></mat-datepicker-toggle>
        <mat-datepicker #certStartDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <input matInput [min]="certSelectedStartDate" [matDatepicker]="certEndDate" placeholder="Fin" (dateChange)="onCertEndDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="certEndDate"></mat-datepicker-toggle>
        <mat-datepicker #certEndDate></mat-datepicker>
      </mat-form-field>
      <div fxFlex></div>
    </div>
    <div fxLayout="row">
      <div fxFlex></div>
      <a [disabled]="!certSelectedEndDate || !certSelectedStartDate" href="/reporte/certification/{{certSelectedStartDate | date: 'yyyy-MM-dd'}}/{{certSelectedEndDate | date: 'yyyy-MM-dd'}}"
        target="_blank" mat-button color="primary">Ver Reporte</a>
    </div>
  </mat-expansion-panel>
</mat-accordion>
